export function setVideoState(state = {url: null, header_style: ''}, action) {
  switch (action.type) {
    case 'VIDEO_PLAYING':
      return action.state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/r_media_controls.js